export { default as createLazyComponent } from './createLazyComponent';
export type {
    LazyComponent,
    ErrorHandlerFunction,
    ErrorHandlerComponent,
} from './createLazyComponent';
export { createLazyOrchestrator, registerLazyOrchestrator } from './lazyOrchestrator';
export { setBundlingConfig } from './setBundlingConfig';
export { LazyAction, LazyImport, LazyModule, unblockLazyLoadCallbacks } from 'owa-bundling-light';
export type { LazyModuleType, LazyActionOptions } from 'owa-bundling-light';
export type { default as ReactBroadComponentType } from './types/BroadComponentType';

// This is allowed in later versions of tslint:
// https://github.com/palantir/tslint/issues/3157
/* tslint:disable:no-namespace */
declare global {
    // Make import available globally
    interface System {
        import<T>(module: string): Promise<T>;
    }

    const System: System;
}
/* tslint:enable:no-namespace */
